export const AUTH_TOKEN = 'Authorization';

export const LOCAL_STORAGE = {
  ID_TOKEN: 'token',
  USER: 'user',
};

export const TITLES = {
  WEBSITE_TITLE: 'Koostream',
}

export const MESSAGES = {
  EMAIL_SUCCESS: 'Your email has been sent successfully!',
  EMAIL_FAILURE: 'Unable to sent email!',
  ADD_STREAM_SUCCESS: 'Player added successfully!',
  ADD_STREAM_FAILURE: 'Failed to add player!',
  UPDATE_STREAM_SUCCESS: 'Streams updated successfully!',
  UPDATE_STREAM_FAILURE: 'Failed to add sreeams!',
  AUTH_SUCCESS: 'User Authenticated!',
  AUTH_FAILURE: 'Invalid user or password!'
}

export const NOT_SOCCER = ['tennis', 'cricket', 'f1', 'boxing|ufc', 'nfl', 'motogp','nba', 'nhl', 'mlb', 'rugby', 'wwe','ufc'];

export const categories = [
  {
    label: 'Soccer',
    value: 'Streams today'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'tennis',
    value: 'tennis'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'MMA',
    value: 'MMA'
  },
  {
    label: 'motogp',
    value: 'motogp'
  },
  {
    label: 'NFL',
    value: 'NFL'
  },
  {
    label: 'NBA',
    value: 'NBA'
  },
  {
    label: 'MLB',
    value: 'MLB'
  },
  {
    label: 'NHL',
    value: 'NHL'
  },
  {
    label: 'Rugby',
    value: 'Rugby'
  },
  {
    label: 'Cricket',
    value: 'cricket'
  }
];

// export const CATGORY_LINKS = [
//   { label: 'Soccer', link: '/' },
//   { label: 'mlb', link: '/fixtures/MLB/MLB' },
//   { label: 'NFL', link: '/fixtures/NFL/NFL' },
//   { label: 'NBA', link: '/fixtures/NBA/NBA' },
//   { label: 'Boxing', link: '/fixtures/Boxing/Boxing' },
//   { label: 'MMA', link: '/fixtures/MMA/MMA' },
//   { label: 'F1', link: '/fixtures/F1/F1' },
//   { label: 'nhl', link: '/fixtures/NHL/NHL' },
// ];

export const CATGORY_LINKS = [
  { label: 'Home', link: '/' },
  { label: 'NFL', link: '/fixtures/NFL/NFL' },
  { label: 'F1', link: '/fixtures/F1/F1' },
  { label: 'UFC', link: '/fixtures/UFC/UFC' },
  { label: 'Boxing', link: '/fixtures/Boxing/Boxing' },
  { label: 'Tennis', link: '/fixtures/tennis/tennis' },
  { label: 'NBA', link: '/fixtures/NBA/NBA' },
  { label: 'Rugby', link: '/fixtures/Rugby/Rugby' },
  { label: 'Cricket', link: '/fixtures/cricket/Cricket' },
  { label: 'MotoGP', link: '/fixtures/motogp/MOTOGP' },
  { label: 'MLB', link: '/fixtures/MLB/MLB' },
  { label: 'NHL', link: '/fixtures/NHL/NHL' },
];

export const ADS = {
  MAIN: {
    TYPE: 'main',
    SLOT: '2554300823'
  },
  FIXTURE_LIST_DISPLAY_HORIZONTAL: {
    TYPE: 'FixtureListDisplayHorizontal',
    SLOT: '3824669050'
  },
  PLAYER_DISPLAY_HORIZONTAL: {
    TYPE: 'playerDisplayHorizontal',
    SLOT: '3744778007'
  },
  VERTICLE_MAIN: {
    TYPE: 'vertical',
    SLOT: '2926488530'
  },
  IN_ARTICLE: {
    TYPE: 'in-article',
    SLOT: '6685754230'
  },
  IN_FEED: {
    TYPE: 'in-feed',
    SLOT: '2184823320'
  },
  SQUARE_DISPLAY: {
    TYPE: 'square-display',
    SLOT: '7807264218'
  },
}

export const PAGE_TITLES: any = {
  WEBSITE_TITLE: 'Koostream | Sports Fixtures, Schedules, Standings & Sports News',
  SOCCER: 'Soccer Fixtures & Match Schedules | Koostream',
  BOXING: 'Boxing Fight Cards & Upcoming Bouts | Koostream',
  NFL: 'NFL Schedule, Fixtures & Game Times | Koostream',
  NBA: 'NBA Schedule & Basketball Fixtures | Koostream',
  UFC: 'UFC Event Schedule & Fight Cards | Koostream',
  MMA: 'MMA Event Schedule & Fight Cards | Koostream',
  TENNIS: 'Tennis Tournament Schedules & Fixtures | Koostream',
  RUGBY: 'Rugby Fixtures & Match Schedules | Koostream',
  MOTOGP: 'MotoGP Calendar & Race Schedules | Koostream',
  NHL: 'NHL Schedule & Hockey Fixtures | Koostream',
  MLB: 'MLB Schedule & Baseball Fixtures | Koostream',
  F1: 'Formula 1 Calendar & Race Schedules | Koostream',
  MLS: 'MLS Schedule & Soccer Fixtures | Koostream',
  CRICKET: 'Cricket Fixtures & Match Schedules | Koostream',
  TEAMS: 'Team Fixtures & Upcoming Matches | Koostream',
  LEAGUES: 'League Fixtures & Competition Schedules | Koostream',
  STANDINGS: 'League Standings & Points Tables | Koostream',
  CONTACT: 'Contact Koostream | Support, Feedback & Copyright Notices',
  ABOUT: 'About Koostream | Sports Fixtures, News & Schedules',
  BLOGS: 'Sports News & Commentary | Koostream Blog',
  PRIVACY: 'Privacy Policy | Koostream',
  DMCA: 'DMCA Copyright Policy | Koostream',
  TERMS: 'Terms of Service | Koostream'
};

export const blogs = [
  {
    title: 'Pierluigi Collina on his career’s most moving moment',
    url: 'Pierluigi-Collina-on-his-careers-most-moving-moment',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/F_njnFaWcAA8vDD.jpg',
    description: 'An editorial look at Pierluigi Collina and the 1999 UEFA Champions League final in Barcelona, one of the most dramatic nights in club football.',
    author: 'Koostream Editorial',
    date: '2024-10-30',
    id: 8
  },
  {
    title: 'The Saddest moments in Football',
    url: 'The-Saddest-moments-in-Football',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/sddefault.jpg',
    description: 'Original commentary on public football moments that still resonate with supporters, from farewells to on-pitch emergencies.',
    author: 'Koostream Editorial',
    date: '2024-10-30',
    id: 7
  },
  {
    title: 'Downfall of Man City',
    url: 'the-downfall-of-man-city',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/downfall-of-man-city.jpeg',
    description: 'Editorial analysis of Manchester City’s difficult Premier League stretch, injuries, and Pep Guardiola’s response.',
    author: 'Koostream Editorial',
    date: '2024-10-30',
    id: 6
  },
  {
    title: 'The Caitlin Clark Effect ',
    url: 'the-caitlin-clark-effect',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/the-caitlin-clark-effect.webp',
    description: 'How Caitlin Clark’s scoring records and WNBA debut changed attention around women’s basketball — original Koostream commentary.',
    author: 'Koostream Editorial',
    date: '2024-10-30',
    id: 5
  },
  {
    title: 'How the new champion’s league format has fared so far',
    url: 'How-the-new-champion’s-league-format-has-fared-so-far',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/Champions-League2.webp',
    description: 'Original commentary on UEFA’s league-phase Champions League format: what changed, who adapted, and why the calendar feels different.',
    author: 'Koostream Editorial',
    date: '2024-10-30',
    id: 1
  },
  {
    title: 'The rise of Calafiori at Arsenal:',
    url: 'The-rise-of-Calafiori-at-Arsenal',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/Calafiori.webp',
    description: 'Riccardo Calafiori’s move from Bologna to Arsenal, his role in Arteta’s defence, and why versatility matters in the Premier League.',
    author: 'Koostream Editorial',
    date: '2024-09-18',
    id: 2
  },
  {
    title: 'Key Players Lighting Up the Stage',
    url: 'Key-Players-Lighting-Up-the-Stage',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/Champions-League.webp',
    description: 'Editorial notes on standout players across Europe’s top clubs, from Bellingham and Kane to Haaland, Saka, and Pedri.',
    author: 'Koostream Editorial',
    date: '2024-09-20',
    id: 3
  },
  {
    title: 'Has Martin Odeegard’s injury been a blessing in disguise for The Arsenal or is it Arsenal’s misfortune?',
    url: 'Has-Martin-Odeegard-injury-been-a-blessing-in-disguise-for-The-Arsenal-or-is-it-Arsenal-misfortune',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/blog2.webp',
    description: 'How Arsenal adapted without captain Martin Ødegaard: midfield structure, Trossard’s minutes, and whether the injury helped or hurt.',
    author: 'Koostream Editorial',
    date: '2024-09-22',
    id: 4
  },
  {
    title: 'Violent Clash among Football Fans',
    url: 'Violent-Clash-among-Football-Fans',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/p0c9r9b6.webp',
    description: 'Why football hooliganism persists, how clubs and police respond, and what actually reduces stadium violence.',
    author: 'Koostream Editorial',
    date: '2025-02-17',
    id: 9
  },
];

export const DEFAULT_SPORTS_LOGO = 'https://res.cloudinary.com/djfixkqyj/image/upload/v1709307398/Images/Default-Sports-Logo_luku1o.webp';
export const DEFAULT_LEAGUE_LINK = '/fixtures/league/Premier League';
export const DEFAULT_TEAM_LINK = '/fixtures/team/Liverpool';
export const LOGO_URL2 = 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/koostream-official-logo-final.webp';
export const LOGO_URL = 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/koostream-website-logo-final.webp';
export const LOGO_URL1 = 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/Logo-final.webp';
